'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  password: {
    button: {
      login: 'Connexion'
    },
    email: {
      meta_title: 'Caligram - Mot de passe oublié',
      title: 'Mot de passe oublié',
      help: 'Saisissez votre adresse courriel et vous recevrez un lien pour réinitialiser votre mot de passe.',
      form: {
        email: 'Courriel',
        submit: 'Envoyer'
      }
    },
    reset: {
      meta_title: 'Caligram - Réinitialiser le mot de passe',
      title: 'Réinitialiser le mot de passe',
      form: {
        email: 'Courriel',
        password: 'Mot de passe',
        submit: 'Réinitialiser le mot de passe'
      }
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/password.js
// module id = 2296
// module chunks = 0